<app-layout>
    <mat-card class="mat-elevation-z0" *ngIf="hasFeatureAccess">
        <mat-card-title class="header">
            <h1 appLocalizationPopupDirective localizationCode="Imports">{{ 'Imports' | translate: {Default: "Imports"} }}</h1>
    
            <button appLocalizationPopupDirective localizationCode="CreateNewImport" mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="editOrCreateImport()">
                <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">add</mat-icon> 
                {{ 'CreateNewImport' | translate: {Default: "Create New Import"} }}
            </button>
        </mat-card-title>
        <mat-card-content>
            <app-data-grid-comp
                [gridId]="gridId"
                hideActionButtons="true"
                [columns]="columns"
                [filterCategories]="filterCategories"
                [gridDataResult]="gridDataResult"
                [pageSize]="pageSize"
                [skip]="skip"
                [clearSelectedItems]="clearSelectedItems"
                [rowSelectionSettings]="{
                    canSelectRows: true,
                    selectableMode: 'multiple',
                    selectRowBy: 'id'
                }"
                clickableRows="true"
                [isLoading]="isLoading"
                searchable="true"
                showRefreshButton="true"
                [rowActionButtons]="gridActionButtons"
                (emitRefreshEvent)="getImports()"
                [sortable]="{
                    mode: 'multiple'
                }"
                [sortableColumns]="sortableColumns"
                (rowActionEvent)="copy($event)"
                (emitOpenDialogEvent)="editOrCreateImport($event)"
                (emitGridStateChangeEvent)="gridStateChange($event)"
                (emitDeleteEvent)="openConfirmDeleteDialog($event)"
            ></app-data-grid-comp>
        </mat-card-content>
    </mat-card>

    <no-feature-access *ngIf="!hasFeatureAccess"></no-feature-access>

</app-layout>